import { DEFAULT_UPDATE_CONFIG_FIELDS } from './constant';

export const namespace = 'reportBuilder';

export const reportStep = {
  detail: 'detail',
  customize: 'customize',
  view: 'view',
}

export const ACTION_TYPES = {
  GET_REPORT_CONFIG: `${namespace}/getReportConfig`,
  UPDATE_SNAPSHOT_CONFIG: `${namespace}/updateSnapshotConfig`,
  UPDATE_CHART_AND_TABLE_CONFIG: `${namespace}/updateChartAndTableConfig`,
  UPDATE_REPORT_TEMPLATE: `${namespace}/updateReportTemplate`,
  UPDATE_USER_CONTACT_INFO_CONFIG_BY_KEY: `${namespace}/updateUserContactInfoConfigByKey`,
  UPDATE_REPORT_PROPERTIES_CONFIG: `${namespace}/updateReportPropertiesConfig`,
  UPDATE_REPORT_PROPERTIES_CONFIG_BY_KEY: `${namespace}/updateReportPropertiesConfigByKey`,
  UPDATE_REPORT_CONFIG_BY_KEY: `${namespace}/updateReportConfigByKey`,
  RESET_REPORT_CONFIG: `${namespace}/resetReportConfig`,
  SET_REPORT_BUILDER_DATA: `${namespace}/SET_REPORT_BUILDER_DATA`,
  SET_REPORT_CHART_SELECTOR: `${namespace}/setReportChartSelector`,
  ADD_DEFAULT_CHART_SELECTOR: `${namespace}/addDefaultChartSelector`,
  SET_TABLE_SORT_SELECTOR: `${namespace}/setReportTableSortSelector`,
  SET_ALL_DEFAULT_REPORT_SELECTOR: `${namespace}/setAllDefaultReportSelector`,
  UPDATE_REPORT_CONFIG_BY_DATE_COMPARE: `${namespace}/updateReportConfigByDateCompare`,
  UPDATE_INITIAL_SNAP_SHOT_BY_ALPHA_MEDIA: `${namespace}/updateInitialSnapshotsByAlphaMedia`
};

export const setReportBuilderData = (reportBuilder) => ({
  type: ACTION_TYPES.SET_REPORT_BUILDER_DATA,
  payload:{
    reportBuilder
  }
});

export const getReportConfig = (config) => ({
  type: ACTION_TYPES.GET_REPORT_CONFIG,
  payload:{
    config
  }
});

export const updateSnapshotConfig = (id, value, isTemplateUpdatedInCustomizeStep) => ({
  type: ACTION_TYPES.UPDATE_SNAPSHOT_CONFIG,
  payload:{
    id,
    value,
    isTemplateUpdatedInCustomizeStep,
  }
});

export const updateChartAndTableConfig = (parentId, id, value, countIndex, isTemplateUpdatedInCustomizeStep) => ({
  type: ACTION_TYPES.UPDATE_CHART_AND_TABLE_CONFIG,
  payload:{
    parentId,
    id,
    value,
    countIndex,
    isTemplateUpdatedInCustomizeStep,
  }
});

export const updateReportTemplateType = (type, trackingDataSourceName = '') => ({
  type: ACTION_TYPES.UPDATE_REPORT_TEMPLATE,
  payload:{
    type,
    trackingDataSourceName
  }
});

export const updateUserContactInfoConfigByKey = (key, value) => ({
  type: ACTION_TYPES.UPDATE_USER_CONTACT_INFO_CONFIG_BY_KEY,
  payload: {
    key,
    value,
  }
});

export const updateReportPropertiesConfig = (reportProperties) => ({
  type: ACTION_TYPES.UPDATE_REPORT_PROPERTIES_CONFIG,
  payload: {
    reportProperties
  }
});

export const updateReportPropertiesConfigByKey = (key, value, isUpdateDate) => ({
  type: ACTION_TYPES.UPDATE_REPORT_PROPERTIES_CONFIG_BY_KEY,
  payload: {
    key,
    value,
    isUpdateDate,
  }
});

export const updateReportConfigByKey = (key, value) => ({
  type: ACTION_TYPES.UPDATE_REPORT_CONFIG_BY_KEY,
  payload: {
    key,
    value,
  }
});

export const resetReportConfig = () => ({
  type: ACTION_TYPES.RESET_REPORT_CONFIG,
});

export const setReportChartSelector = (chartId, chartIndex, updatedSelector) => ({
  type: ACTION_TYPES.SET_REPORT_CHART_SELECTOR,
  payload: {
    chartId,
    chartIndex,
    updatedSelector
  }
});

export const addDefaultChartSelector = (chartId, chartSelector) => ({
  type: ACTION_TYPES.ADD_DEFAULT_CHART_SELECTOR,
  payload: {
    chartId,
    chartSelector,
  }
});

export const setReportTableSortSelector = (tableId, tableIndex, sortSelector) => ({
  type: ACTION_TYPES.SET_TABLE_SORT_SELECTOR,
  payload: {
    tableId,
    tableIndex,
    sortSelector,
  }
})

export const setAllDefaultReportSelector = (chartSelector, tableSortSelector) => ({
  type: ACTION_TYPES.SET_ALL_DEFAULT_REPORT_SELECTOR,
  payload: {
    chartSelector,
    tableSortSelector
  }
}) 

export const updateReportConfigByDateCompare = (updatingConfigFields = DEFAULT_UPDATE_CONFIG_FIELDS) => ({
  type: ACTION_TYPES.UPDATE_REPORT_CONFIG_BY_DATE_COMPARE,
  payload: {
    updatingConfigFields,
  }
})

export const updateInitialSnapshotsByAlphaMedia = (reportBuilderSnapshot) => ({
  type: ACTION_TYPES.UPDATE_INITIAL_SNAP_SHOT_BY_ALPHA_MEDIA,
  payload: {
    reportBuilderSnapshot,
  }
})